import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Radio } from "antd";
import Form, { FormInputComponent } from '../../../components/form/Form';
import { useAuth } from '../../../providers/AuthProvider';
import { CommitmentOptions } from '../../talent-preferences/components/DashboardPreferences';


const JobProfileResumeModal = props => {
    const { auth, talentUpdate } = useAuth();
    const [isUpdating, setIsUpdating] = useState(false);

    const [formModel, setFormModel] = useState(TB.pick(auth, [
        'talent_commitment_level',
        'resume_path',
        'has_full_time_employment_interest',
        // 'has_contract_to_hire_interest',
    ]))

    const mapping = (model) => {
        let result = { ...model };

        for (let [key, value] of Object.entries(model)) {
            result = TB.set(result, key, value);
        }
        // result.has_contract_to_hire_interest = result.has_contract_to_hire_interest ? 1 : 0;

        return result;
    }


    return (
        <div className="preferences-reminder">
            <div className="reminder-header">
                Your Proposal has been updated. Please take the time to update the items below
            </div>


            <div className="p-3 md:p-5">
                <h3 className="text-lg">
                    <span className="text-red-500 font-bold pr-1.5">!</span>
                    Important items are out of date or missing from your profile.
                </h3>

                <Form
                    // ref={this.formRef}
                    showRequired
                    className="job-profile-resume-form"
                    background={'transparent'}
                    title={null}
                    subtitle={null}
                    submitButton={false}
                    mapping={model => mapping(model)}
                    onSubmit={null}
                    model={formModel}
                    onChange={(model) => {
                        if (isUpdating) return;

                        let updates = { ...formModel };

                        for (let [key, value] of Object.entries(model)) {
                            updates = TB.set(updates, key, value)
                        }
                        return setFormModel(mapping(updates));
                    }}
                    fields={[]}
                    isDisabled={isUpdating}
                >

                    <div className="flex flex-col items-stretch self-stretch flex-grow gap-10">
                        <div>
                            <p className="mb-4 p-2 bg-light-gray2 inline-block">
                                {typeof formModel?.resume_path === 'string' ? (
                                    "We have your resume but it's a good idea to keep your resume up to date if there are any changes. Clients prefer to see the most up-to-date information"
                                ) : (
                                    "We don't currently have a resume on file for you. Most clients still prefer to see a candidates resume."
                                )}
                            </p>

                            <div className="flex flex-col self-stretch items-stretch max-w-[450px]">

                                <FormInputComponent
                                    fieldName="resume_path"
                                    value={formModel.resume_path}
                                    type="file"
                                    disabled={isUpdating}
                                    size={formModel?.resume_path?.size}
                                    viewable={typeof formModel?.resume_path === 'string'}
                                    label={<p className="text-bold">{typeof formModel?.resume_path === 'string' ? "Update" : "Upload"} a PDF version of your resume (Recommended)</p>}
                                    fileNameDisplay={(fileData) => {
                                        if (typeof formModel?.resume_path === 'string') {
                                            return auth?.resumeDocument()?.name || fileData.name;
                                        }
                                        return formModel?.resume_path?.name || fileData.name;
                                    }}
                                />
                            </div>
                        </div>

                        <div>
                            <p className="mb-4 p-2 bg-light-gray2 inline-block">Please check and update your job preferences below</p>
                            <div className="flex flex-col items-start gap-y-4 gap-x-10 md:flex-row">
                                <div className="flex flex-col items-stretch">
                                    <FormInputComponent
                                        value={formModel.talent_commitment_level}
                                        fieldName="talent_commitment_level"
                                        label="Describe your current work status"
                                        type="antd-input"
                                    >
                                        <Radio.Group
                                            className="flex gap-4"
                                            name="talent_commitment_level"
                                        >
                                            {Object.keys(CommitmentOptions).map(key => {
                                                return (
                                                    <Radio value={Number(key)}>
                                                        <span className="flex flex-col items-start gap-1">
                                                            <span className="text-sm font-medium">
                                                                {CommitmentOptions[key].title}
                                                            </span>
                                                            <span className="text-xxs">
                                                                {CommitmentOptions[key].description}
                                                            </span>
                                                        </span>
                                                    </Radio>
                                                )
                                            })}
                                        </Radio.Group>
                                    </FormInputComponent>
                                </div>
                                {/* <div className="flex flex-col items-stretch basis-1/3">
                                    <FormInputComponent
                                        fieldName="has_contract_to_hire_interest"
                                        value={formModel.has_contract_to_hire_interest ? 1 : 0}
                                        label={TB.trans('talent.project_interests.has_contract_to_hire_interest_label')}
                                        type="switch"
                                        onLabel={TB.trans('talent.project_interests.has_contract_to_hire_interest_on_label')}
                                        offLabel={TB.trans('talent.project_interests.has_contract_to_hire_interest_off_label')}
                                        required={false}
                                        disabled={isUpdating}
                                        style={{padding: '0 8px'}}
                                        switchStyle={{
                                            onColor: TB.config('color.light_green'), // green
                                            offColor: '#90A0B7', // dark gray
                                            textColor: '#000000', // black
                                        }}
                                    />
                                </div> */}
                            </div>
                            <div>
                                <FormInputComponent
                                    value={formModel.has_full_time_employment_interest}
                                    fieldName="has_full_time_employment_interest"
                                    label="Would you be interested in a permanent employment opportunity?"
                                    type="antd-input"
                                >
                                    <Radio.Group
                                        className="flex gap-2"
                                        optionType="button"
                                        buttonStyle="solid"
                                    >
                                        <Radio value={true} className="flex flex-col items-start justify-center">
                                            Yes
                                        </Radio>
                                        <Radio value={false} className="flex flex-col items-start justify-center">
                                            No
                                        </Radio>
                                    </Radio.Group>
                                </FormInputComponent>
                            </div>
                        </div>
                    </div>
                </Form>

            </div>

            <div className="flex w-full justify-end p-4 mt-auto gap-3">
                <button disabled={isUpdating} type="button" className="btn btn-primary" onClick={async () => {
                    await setIsUpdating(true)

                    let updated = await talentUpdate(formModel);

                    setIsUpdating(false)
                    if (updated) {
                        TB.toast('Profile updated successfully');
                    } else {
                        return TB.showServerErrorToast();
                    }

                    return props.onRequestClose()
                }}>
                    Save Updates
                </button>

                <button disabled={isUpdating} onClick={() => props.onRequestClose()} className="btn btn-outline-dark">
                    Close
                </button>
            </div>
        </div>
    );
};

export default JobProfileResumeModal;

JobProfileResumeModal.propTypes = {
    disabled: PropTypes.bool,
    onRequestClose: PropTypes.func,
};